export default __webpack_public_path__ + "static/news25-70149a49d0b9d3f716d1d34c9c663fb5.jpg";